import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var InvoiceState;
(function (InvoiceState) {
    InvoiceState["NONE"] = "NONE";
    InvoiceState["OPEN"] = "OPEN";
    InvoiceState["CHARGED"] = "CHARGED";
    InvoiceState["PAID"] = "PAID";
    InvoiceState["CANCELED"] = "CANCELED";
    InvoiceState["SPLIT"] = "SPLIT";
    InvoiceState["BAD_DEBT"] = "BAD_DEBT";
    InvoiceState["ARCHIVED"] = "ARCHIVED";
})(InvoiceState || (InvoiceState = {}));
export var Invoicing;
(function (Invoicing) {
    Invoicing["NONE"] = "NONE";
    Invoicing["AFTER_RUNTIME"] = "AFTER_RUNTIME";
    Invoicing["START_RUNTIME"] = "START_RUNTIME";
    Invoicing["IMMEDIATELY"] = "IMMEDIATELY";
    Invoicing["CREDIT"] = "CREDIT";
    Invoicing["BY_DELIVERY_500"] = "BY_DELIVERY_500";
    Invoicing["BY_POSITION_END_DATE_MONTH"] = "BY_POSITION_END_DATE_MONTH";
    Invoicing["BY_POSITION_END_DATE_QUARTER"] = "BY_POSITION_END_DATE_QUARTER";
    Invoicing["BY_POSITION_END_DATE_HALFYEAR"] = "BY_POSITION_END_DATE_HALFYEAR";
})(Invoicing || (Invoicing = {}));
export var UpdateMode;
(function (UpdateMode) {
    UpdateMode["ALL"] = "ALL";
    UpdateMode["EMPTY_ONLY"] = "EMPTY_ONLY";
    UpdateMode["NONE"] = "NONE";
})(UpdateMode || (UpdateMode = {}));
export var BillingType;
(function (BillingType) {
    BillingType["FIXED_PRICE"] = "FIXED_PRICE";
    BillingType["CPS"] = "CPS";
    BillingType["CPW"] = "CPW";
})(BillingType || (BillingType = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["ALL"] = "ALL";
    CampaignStatus["OFFERED"] = "OFFERED";
    CampaignStatus["PREPAYMENT"] = "PREPAYMENT";
    CampaignStatus["BOOKED"] = "BOOKED";
    CampaignStatus["RUNNING"] = "RUNNING";
    CampaignStatus["ARCHIVED"] = "ARCHIVED";
})(CampaignStatus || (CampaignStatus = {}));
